import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { IncidentsColorScheme } from '@/generated/prisma';

export const QUERY_KEY_INCIDENTS_COLOR_SCHEME_QUERY = 'incidents-color-scheme';

type QueryParams = { enabled?: boolean };

type Response = Omit<UseQueryResult<IncidentsColorScheme, unknown>, 'data'> & {
  colorSchemes: IncidentsColorScheme | null;
};

export const useIncidentsColorScheme = ({ enabled = true }: QueryParams = {}): Response => {
  const { orgId } = useCurrentUser();

  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_INCIDENTS_COLOR_SCHEME_QUERY, orgId],
    queryFn: () => Api.incidents.getColorScheme(orgId),
    enabled: enabled && !!orgId,
  });

  return { colorSchemes: data ?? null, ...query };
};
